<template>
  <Navbar/>
  <div class="container">
    <h3 class="text-warning text-center pt-5 mt-5">
      Nie posiadasz uprawnień do wykonania tej akcji
    </h3>
    <div class="text-center">
      <router-link to="/" class="btn btn-primary btn-sm">
        Wróć do strony głównej
      </router-link>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Unauthorized',
  components: { Navbar },
  created () {
    this.$store.commit('setInitialCalendarLoading', true)
  }
}
</script>
